import React, { Dispatch, SetStateAction } from 'react';
import { ClientList } from 'types/clientList';
import { Table } from 'components';
import TableHeadGroup from './TableHeadGroup';
import TableRowsGroup from './TableRowsGroup';

type Props = {
  onUploadClick: (clientId: string) => void;
  onSortChange?: Dispatch<SetStateAction<Sorters>>;
  disableSorting?: boolean;
  isLoading?: boolean;
  items: ClientList[];
  sort?: Sorters;
};

const TableUsers: React.FC<Props> = ({
  onSortChange = () => {},
  onUploadClick = () => {},
  disableSorting,
  isLoading = false,
  items = [],
  sort,
}) => {
  const isEmpty = !Boolean(items.length);

  return (
    <>
      <Table
        colSpan={8}
        isEmpty={isEmpty}
        isLoading={isLoading}
        mb={4}
        minWidth={1024}
        tableLayout="fixed"
      >
        <TableHeadGroup
          disableSorting={!Boolean(items.length) || disableSorting}
          onSortChange={onSortChange}
          sort={sort}
        />
        <TableRowsGroup items={items} onUploadClick={onUploadClick} />
      </Table>
    </>
  );
};

export default TableUsers;
